



import EventSettingPrintComponent from "@/components/admin/event/eventSettingPrintComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventSettingPrintPage",
  components: {
    EventSettingPrintComponent,
  },
})
export default class EventSettingPrintPage extends Vue {}
